import { Button, Divider, Text } from "@growtherapy/sprout-ui";
import { twMerge } from "tailwind-merge";
import { useClientLogin } from "./useClientLogin";
import { useTranslate } from "@growtherapy/i18n";

export type LoginSectionProps = {
  className?: string;
  instructionClassName?: string;
  isAuthenticated?: boolean;
  onLogin?: () => void;
};

function SectionDivider() {
  const t = useTranslate();
  return (
    <div className="flex items-center justify-center w-full relative">
      <Divider className="absolute" use="secondary" />
      <Text className="text-neutral-700 bg-neutral-100 px-2 relative">
        {t("telehealth-core:introRoom.preferNotToLogin")}
      </Text>
    </div>
  );
}

function LoginCta({
  onLogin,
  className,
  instructionClassName,
}: Pick<LoginSectionProps, "onLogin" | "className" | "instructionClassName">) {
  const t = useTranslate();
  return (
    <div
      className={twMerge("flex flex-col w-full gap-4 items-center", className)}
    >
      <Text
        className={twMerge("font-medium text-center", instructionClassName)}
      >
        {t("telehealth-core:introRoom.loginToAccessYourSharedTopics")}
      </Text>
      <Button className="w-full" onClick={onLogin}>
        {t("telehealth-core:core.logIn")}
      </Button>
    </div>
  );
}

/** A section that allows the user to authenticate in telehealth. */
export function LoginSection({
  className,
  instructionClassName,
  isAuthenticated,
  onLogin,
}: LoginSectionProps) {
  if (isAuthenticated) return null;
  return (
    <div className="flex flex-col w-full gap-8">
      <LoginCta
        onLogin={onLogin}
        className={className}
        instructionClassName={instructionClassName}
      />
      <SectionDivider />
    </div>
  );
}

export function LoginSectionWrapper(
  props: Pick<LoginSectionProps, "className" | "instructionClassName">,
) {
  const { handleLogin, isAuthenticated, isClientAuthEnabled } =
    useClientLogin();

  if (!isClientAuthEnabled) return null;

  return (
    <LoginSection
      isAuthenticated={isAuthenticated}
      onLogin={handleLogin}
      {...props}
    />
  );
}
